// extracted by mini-css-extract-plugin
module.exports = {"valuesContainer":"CommonInfoSection_valuesContainer__pGaRH","attributeGrid":"CommonInfoSection_attributeGrid__yIvSL"};